import { motion } from "framer-motion";
import { Shield, CheckCircle } from "lucide-react";
import ApplyCta from "./ApplyCta";

const ServiceGuarantee = () => {
  return (
    <section
      id="garantia"
      className="py-20 md:py-28 relative overflow-hidden"
      style={{ background: "linear-gradient(180deg, #1a2d4c 0%, #0a162a 100%)" }}
    >
      <div className="container px-4">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="max-w-4xl mx-auto"
        >
          <div className="bg-white/5 backdrop-blur-sm rounded-3xl p-8 md:p-12 border border-white/10">
            {/* Icon */}
            <div className="text-center mb-8">
              <div className="w-20 h-20 rounded-full bg-[#7ab7fd] flex items-center justify-center mx-auto mb-6 shadow-lg shadow-[#7ab7fd]/30">
                <Shield className="w-10 h-10 text-[#0a162a]" />
              </div>

              <span className="inline-block px-4 py-1.5 rounded-full border border-[#7ab7fd]/50 bg-[#7ab7fd]/20 text-white text-sm font-medium tracking-widest mb-4">
                GARANTÍA CORESSEN®
              </span>

              <h2 className="font-display text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-4">
                Coherencia estratégica{" "}
                <span className="text-[#7ab7fd]">garantizada</span>
              </h2>
            </div>

            {/* Content */}
            <div className="space-y-6 text-center">
              <p className="text-white/80 text-lg leading-relaxed max-w-2xl mx-auto">
                Garantizamos coherencia estratégica entre marca, negocio y visión.
              </p>

              <div className="bg-white/5 rounded-2xl p-6 border border-white/10">
                <p className="text-white/70 leading-relaxed">
                  Si alguna definición no refleja el nivel real del negocio o su potencial de valor,
                  <span className="text-[#7ab7fd] font-semibold">
                    {" "}
                    se ajusta dentro del proceso hasta lograr alineación total
                  </span>
                  .
                </p>
              </div>

              <div className="flex flex-col md:flex-row gap-4 justify-center items-center pt-4">
                <div className="flex items-center gap-2 text-white/80">
                  <CheckCircle className="w-5 h-5 text-[#7ab7fd]" />
                  <span>Solidez estratégica</span>
                </div>
                <div className="hidden md:block w-1 h-1 rounded-full bg-white/30" />
                <div className="flex items-center gap-2 text-white/80">
                  <CheckCircle className="w-5 h-5 text-[#7ab7fd]" />
                  <span>Valor marcario sostenible</span>
                </div>
                <div className="hidden md:block w-1 h-1 rounded-full bg-white/30" />
                <div className="flex items-center gap-2 text-white/80">
                  <CheckCircle className="w-5 h-5 text-[#7ab7fd]" />
                  <span>Crecimiento con esencia</span>
                </div>
              </div>
            </div>

            {/* Bottom tagline */}
            <div className="mt-10 pt-8 border-t border-white/10 text-center">
              <p className="text-white/60 italic">
                <span className="text-[#7ab7fd] font-semibold">BrandWay©</span> desarrolla
                una identidad que acompaña la evolución del negocio.
                <br />
                Una marca preparada para crecer, sostener prestigio y crear valor a largo plazo.
              </p>
            </div>

            <ApplyCta variant="dark" />
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default ServiceGuarantee;
